import React from "react";
import TextInput, { TextInputProps } from "../TextInput/TextInput";
import Text from "../../Text/Text";
import SearchIcon from "../../../icons/SearchIcon";
import { useString } from "../../../i18n/GetText";

const Search = ({ className, onChange, onKeyPress, value }: SearchProps) => {
  const searchString = useString("search");
  return (
    <Text className={className} variant="defaultLight" as="div">
      <TextInput
        role="search"
        type={"search"}
        icon={
          <SearchIcon
            height={20}
            stroke={"#556c84"}
            strokeWidth={0.5}
            width={20}
          />
        }
        aria-label={searchString}
        labelVisuallyHidden
        onChange={onChange}
        onKeyPress={onKeyPress}
        value={value}
        placeholder={searchString}
      />
    </Text>
  );
};

export default Search;

interface SearchProps extends TextInputProps {
  className?: string;
  value: string;
}
